<template>
  <v-container fluid class="district-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/district/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="districts-table"
              show-select
              single-select
              item-key="_id"
              sort-by="districtname"
              :footer-props="footer"
              :headers="headers"
              :items="districts"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteDistrict"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this District?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_district.districtname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteDistrict = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_district)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.districtname="{ item }">
                <p class="two-line"><strong>{{ item.districtname }}</strong></p>
                <p class="two-line">{{ item.districtnameinfo  }}</p>
              </template>
              <template v-slot:item.districtemail="{ item }">
                <a class="primaryConst--text">{{ item.districtemail }}</a>
              </template>
              <template v-slot:item.districtid="{ item }">
                {{ item.districtid }}
              </template>
              <template v-slot:item.districtstatus="{ item }">
                <v-chip
                  :color="!item.districtstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.districtstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDistrict(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'districtList',
  data() {
    return {
      isDeleteDistrict: false,
      delete_district: {},
      headers: [
        { text: 'Type', value: 'districttype' },
        { text: 'Name', value: 'districtname' },
        { text: 'Code', value: 'districtcode' },
        { text: 'Status', value: 'districtstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      districtid: ['admin', 'district'],
    }
  },

  computed: {
    ...mapState('District', ['districts', 'isReceiving', 'isDeleting', 'idToDelete', 'districtsMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit district'
    },
  },
  created () {
    this.getDistrictsRequest()
  },
  methods: {
    ...mapActions('District', ["getDistrictsRequest","deleteDistrictRequest","updateDistrictRequest","createDistrictRequest"]),
    editItem(item) {
      this.$router.push({ name: 'DistrictEdit', params: item })
    },
    deleteItem(item) {
      this.deleteDistrictRequest({_id: item._id});
      this.isDeleteDistrict = false;
    },
    deleteDistrict(item) {
      this.isDeleteDistrict = true;
      this.delete_district = {_id: item._id, districtname: item.districtname};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
